import {
  DesaturateFilter,
  ImageScaleView,
  View,
} from '@play-co/timestep-core/ui';
import { AssetGroup } from '@play-co/timestep-core';
import { spineLoader } from '@play-co/timestep-spine';
import { ButtonScaleViewOpts } from 'src/lib/ui/components/ButtonScaleView';
import { FeatureButton } from 'src/game/components/FeatureButton';
import { downscale } from 'src/conf/scale';
import { now, user } from 'src/StateObserver';
import {
  jankenGetCurrentEvent,
  jankenIsEventActive,
} from 'src/replicant/janken/janken.getters';
import {
  getJankenBlockedReason,
  hasUnresolvedEntryChallenge,
  hasUnclaimedResultEntry,
} from '../janken.sequence';

const assets = {
  spine: {
    loadMethod: spineLoader,
    url: 'assets/ui/janken/animation/spine.janken_icon',
  },
  timerBg: 'assets/ui/janken/icons/janken_label.png',
  lockIcon: 'assets/ui/accessories/icons/lock_icon.png',
};

export class JankenHudButton extends FeatureButton {
  private lockIcon: ImageScaleView;
  private desaturateFilter = new DesaturateFilter(0.75);

  constructor(opts: ButtonScaleViewOpts) {
    super({
      width: 144,
      height: 160,
      pressedOffsetY: 5,
      labelPanel: {
        width: downscale(204),
        height: downscale(66),
        offsetY: 0,
        labelOffsetY: -3,
        background: {
          image: assets.timerBg,
        },
      },
      ...opts,
    });

    this.animationStateMap = {
      main: {
        type: 'spine',
        assetGroup: new AssetGroup(Object.values(assets)),
        url: assets.spine.url,
        scale: 0.66,
        offsetX: 0,
        offsetY: 0,
        sequence: ['icon_idle'],
        onEnter: () => this.setLockedState(getJankenBlockedReason() !== null),
      },
    };

    this.lockIcon = new ImageScaleView({
      superview: this,
      image: assets.lockIcon,
      width: 50,
      height: 59,
      x: this.style.width - 26,
      y: 40,
      centerOnOrigin: true,
      zIndex: 100,
      visible: false,
    });

    this.setNotification({
      condition: () =>
        hasUnresolvedEntryChallenge() || hasUnclaimedResultEntry(),
    });
  }

  private setLockedState(locked: boolean) {
    const elements: (View | undefined)[] = [this.spine];
    if (this.labelPanel) {
      elements.push(...this.labelPanel.getSubviews());
    }
    if (locked) {
      elements.forEach((el) => el?.setFilter(this.desaturateFilter));
      this.lockIcon.show();
      this.notification?.hide();
    } else {
      elements.forEach((el) => el?.removeFilter());
      this.lockIcon.hide();
      this.notification?.show();
    }
  }

  public update() {
    if (!jankenIsEventActive(user(), now())) {
      this.hide();
      return;
    }

    const event = jankenGetCurrentEvent(user(), now());
    this.setLabelTime({ duration: event?.remainingTime ?? 0 });

    this.show();
    this.setAnimationState('main');
    this.setLockedState(getJankenBlockedReason() !== null);
  }
}
